import FoodsApi from "@/packages/api/Api/V1/FoodsApi";
import { jsonHeaders } from "@/packages/dashboard/csrf";
import { withAppDomain } from "@/packages/dashboard/utils/url-utils";
import { foodItemSchema } from "@/packages/dashboard/api/get-meals";
import { z } from "zod";

const foodItemsResponseSchema = z.object({
  food_items: z.array(foodItemSchema),
});

export type FoodItemsResponse = z.infer<typeof foodItemsResponseSchema>;

export async function getFoodItems(): Promise<FoodItemsResponse> {
  const url = withAppDomain(FoodsApi.index.path());
  const response = await fetch(url, {
    headers: jsonHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch food items: ${response.statusText}`);
  }

  const data = await response.json();
  return foodItemsResponseSchema.parse(data);
}
